import { render, staticRenderFns } from "./StateReportIssue.vue?vue&type=template&id=74a708e8&scoped=true&"
import script from "./StateReportIssue.vue?vue&type=script&lang=js&"
export * from "./StateReportIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a708e8",
  null
  
)

export default component.exports